import gql from 'graphql-tag'

const campagne = gql`
  query campagne (
    $limit: Int!,
    $offset: Int,
    $where: CampagneFilterInput,
    $orderBy: [CampagneOrderBy]
  ) {
    campagne (
      limit: $limit,
      offset: $offset,
      where: $where,
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        id
        nome
        tipoCampagnaId
        tipoCampagna {
          id
          tipo
        }
      }
    }
  }
`

export default campagne

// costo
// numeroContatti
// numeroAppuntamenti


// WEBPACK FOOTER //
// ./src/graphql/queries/campagne.js